import { Component, EventEmitter, Output, Input } from '@angular/core';
import { NoteUpd } from '../../shared/models/NoteUpd';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../shared/static/common-functions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { MessageInfo } from '../../shared/models/MessageInfo';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../shared/models/GItem';
import { DispatchPartsBus } from '../../shared/models/DispatchPartsBus';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

@Component({
    selector: 'dispatch-add-part-dialog',
    templateUrl: './dispatch-add-part-dialog.component.html',
    styleUrls: ['./dispatch-add-part-dialog.component.scss']
})
export class DispatchAddPartDialogComponent  {

    constructor(globals: GlobalsService, private svc_data: DispatchesService) {

    }
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    inventoryLocationId: any;
    partId: any;
    inventoryLocationXrefid: any;
    partNumber: string;
    partDescription: string;
    partQuantity:number
    active: boolean = false;
    inventorySearch: boolean = false;
    data: any;
    gridData: v_DispatchAssignmentBus[];
    action: CRUDActions;
    techId: string;
    assignmentDateTime: Date;
    code: string;
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() sublings: GItem[] =[];
    truckList: GItem[] = []
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;

    }
    ok() {
        let result: ConfirmOutput = {
            action: this.action, dialogResult: CPDialogResult.ok, data: { techId: this.techId, assignmentDateTime: this.assignmentDateTime}, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(list: GItem[]) {

        this.active = true;
        this.truckList = list;
        this.inventoryLocationId = null;
        if (this.truckList.length > 0) {
            this.inventoryLocationId = this.truckList[0].value;
        }
        this.partId = null;
        this.partNumber = null;
        this.partDescription = null;

    }
    searchParts() {
        if (this.inventoryLocationId) {
            this.inventorySearch = true;
        }
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };

    public getNewPart() {

        let dispatchPartsBus: DispatchPartsBus = new DispatchPartsBus();

        var selecttruck = this.truckList.find(ev => ev.value === this.inventoryLocationId)
        if (selecttruck) {

            dispatchPartsBus.personId = selecttruck.category;

        }

        dispatchPartsBus.dispatchPartId = '00000000-0000-0000-0000-000000000000';
        //     dispatchPartsBus.dispatchId =
        dispatchPartsBus.inventoryLocationXrefid = this.inventoryLocationXrefid;
        dispatchPartsBus.inventoryLocationId = this.inventoryLocationId;
        dispatchPartsBus.inventoryId = this.partId;
        dispatchPartsBus.quantity = this.partQuantity;
        dispatchPartsBus.addedDate = new Date (Date.now());
        dispatchPartsBus.insertDt = new Date(Date.now());
        dispatchPartsBus.updateDt = new Date(Date.now());

        return dispatchPartsBus;

    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    inventorySelected(value: any) {

        this.inventorySearch = false;
        if (value != null) {
            this.partId = value.InventoryId;
            this.inventoryLocationXrefid = value.InventoryLocationXREFId;
            this.partNumber = value.Number;
            this.partDescription = value.FullDescription;
        }
        else {
            this.inventorySearch = false;
        }

    }
}

